const BlurImage =
  'PHN2ZyB3aWR0aD0iNjg0IiBoZWlnaHQ9IjY4NCIgdmlld0JveD0iMCAwIDY4NCA2ODQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2ODQiIGhlaWdodD0iNjg0IiByeD0iNCIgZmlsbD0iI0VGRUZGMiIvPgo8L3N2Zz4K'

export default BlurImage
